export default __webpack_public_path__ + "static/media/Icon feather-check-circle.8004abfe.svg";